import { useNavigate, useParams } from 'react-router-dom';
import UserDetail from './UserManage';
import UserHistory from "./UserHistory"
import { FormProvider } from 'react-hook-form';
import { ChevronLeft } from 'lucide-react';


const UserManagement = () => {
    const { id } = useParams();
    const navigate = useNavigate()

    return (
        <FormProvider>
            <div className='d-flex justify-content-between align-items-center mb-3'>
                <h4 className="pb-2 d-flex align-items-center">
                    <ChevronLeft size={18} className="me-2" onClick={() => navigate('/user-management')} style={{ cursor: "pointer" }} />
                    User Details
                </h4>
            </div>

            <div className="ad_pg_bx bg-white">
                <div className="row">
                    <UserDetail id={id} />

                    <hr />
                    <div className="ad_pg_bx bg-white">
                        <UserHistory />
                    </div>
                </div>
            </div>
        </FormProvider>
    );
};

export default UserManagement;

